module.exports = __webpack_public_path__ + "static/media/002.fd72d900.jpg";